import * as React from "react";

export const IconArrowDown = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19.82 5.94L11.94 13.82L4.06 5.94L1.94 8.06L11.94 18.06L21.94 8.06L19.82 5.94Z" fill={props.fill || "currentColor"} />
  </svg>
);
